/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint-disable max-len */
import VoyageReportsService from '../../services/VoyageReportsService';
import VesselActivitiesService from '../../services/VesselActivitiesService';
import ECargoService from '../../services/EcargoService';
import ValidationService from '../../services/ValidationService';
import Idb from '../../services/IndexedDbService';
import ErrorHandlerHelpers from '../../mixins/ErrorHandlerHelpers';
import ForesightService from '../../services/ForesightService';
import VesselActivityCargoService from '../../services/VesselActivityCargoService';
import VesselActivityDeckSpaceCalculatorMixin from '../../mixins/VesselActivityDeckSpaceCalculatorMixin';
import DataSyncService from '../../services/DataSyncService';
import dateTimeHelpers from '../../mixins/DateTimeHelpers';

const SET_VOYAGE_REPORTS = 'SET_VOYAGE_REPORTS';
const CLEAR_VOYAGE_REPORTS = 'CLEAR_VOYAGE_REPORTS';

const SET_VOYAGE_REPORT_DETAILS_DATA = 'SET_VOYAGE_REPORT_DETAILS_DATA';
const CLEAR_VOYAGE_REPORT_DETAILS_DATA = 'CLEAR_VOYAGE_REPORT_DETAILS_DATA';

const SET_VESSEL_ACTIVITES = 'SET_VESSEL_ACTIVITIES';
const CLEAR_VESSEL_ACTIVITIES = 'CLEAR_VESSEL_ACTIVITIES';

const SET_VOYAGE_VALIDATION_REPORT = 'SET_VOYAGE_VALIDATION_REPORT';
const CLEAR_VOYAGE_VALIDATION_REPORT = 'CLEAR_VOYAGE_VALIDATION_REPORT';

const SET_ECARGO_VOYAGE_DETAILS = 'SET_ECARGO_VOYAGE_DETAILS';
const CLEAR_ECARGO_VOYAGE_DETAILS = 'CLEAR_ECARGO_VOYAGE_DETAILS';

const SET_FORESIGHT_VOYAGE_DETAILS = 'SET_FORESIGHT_VOYAGE_DETAILS';
const CLEAR_FORESIGHT_VOYAGE_DETAILS = 'CLEAR_FORESIGHT_VOYAGE_DETAILS';

const SET_VESSEL_ACTIVITIES_CARGO = 'SET_VESSEL_ACTIVITIES_CARGO';
const CLEAR_VESSEL_ACTIVITIES_CARGO = 'CLEAR_VESSEL_ACTIVITIES_CARGO';

const SET_CALCULATING_DECK_SPACE_BOOL = 'SET_CALCULATING_DECK_SPACE_BOOL';

const state = {
  voyageReports: [],
  voyageReportDetailsData: null,
  voyageVesselActivities: [],
  voyageValidationReport: null,
  bulkTransactionsForVesselActivity: [],
  eCargoVoyageCargo: null,
  foresightRequestsForVoyage: null,
  vesselActivitiesCargo: [],
  isCalculatingDeckSpace: false,
};


// GETTERS
const getters = {
  getSyncedAndUnSyncedVoyageReports:
    (state, getters, rootState) => {
      // Filter synced VRs with not-synced VRs with
      // matching Ids due duplicate made when updating ATA/ATD while offline
      const syncedIdFilter = rootState.dataSyncStore.voyageReportsToBeSynced.map((x) => x.id);

      // filter out VRs with matching ids
      const filteredSyncedVoyageReports = state.voyageReports
        .filter((x) => !syncedIdFilter.includes(x.id));

      const result = []
        .concat(rootState.dataSyncStore.voyageReportsToBeSynced.reverse() || [])
        .concat(filteredSyncedVoyageReports)
        .filter((x) => !!x);

      const sortedResult = result.sort((a, b) => {
        if (!a.voyageStartDateTimeLt) return -1;
        if (!b.voyageStartDateTimeLt) return 1;
        if (a.voyageStartDateTimeLt < b.voyageStartDateTimeLt) return 1;
        if (a.voyageStartDateTimeLt > b.voyageStartDateTimeLt) return -1;
        return 0;
      });

      return sortedResult;
    },
  getSyncedAndUnSyncedVesselActivities:
    (state, getters, rootState) => {
      // Filter synced activities with not-synced activities with
      // matching Ids due duplicate made when updating EndDateTimeLT
      // from stopwatch
      const syncedIdFilter = rootState.dataSyncStore.vesselActivitiesToBeSynced
        .map((x) => x.id);

      // filter out activities with matching ids
      const filteredSyncedActivities = state.voyageVesselActivities
        .filter((x) => !syncedIdFilter.includes(x.id));

      const syncedAndUnsynced = []
        .concat(rootState.dataSyncStore.vesselActivitiesToBeSynced || [])
        .concat(filteredSyncedActivities)
        .filter((x) => !!x);

      // Sort by StartDateTimeLt then EndDateTimeLt (desc)
      const sortedActivities = syncedAndUnsynced
        .sort((a, b) => {
          if (!a.endDateTimeLt) return 1;
          if (!b.endDateTimeLt) return -1;
          if (a.startDateTimeLt < b.startDateTimeLt) return -1;
          if (a.startDateTimeLt > b.startDateTimeLt) return 1;
          if (a.endDateTimeLt < b.endDateTimeLt) return -1;
          if (a.endDateTimeLt > b.endDateTimeLt) return 1;
          return -1;
        }).reverse();

      return sortedActivities;
    },
  getSyncedAndUnSyncedCargoForLocation:
    (state, getters, rootState) => (isOutbound, locationName) => {
      var cargoLines = [];
      var cargoLinesToReturn = [];

      //cargo lines from Flow
      if (isOutbound) {
        cargoLines = state.eCargoVoyageCargo.outbound ? state.eCargoVoyageCargo.outbound.cargoLines.filter((x) => {
          return (x.destination.toLowerCase() === locationName.toLowerCase());
        }) : [];
      }
      else {
        cargoLines = state.eCargoVoyageCargo.inbound ? state.eCargoVoyageCargo.inbound.cargoLines.filter((x) => {
          return (x.destination.toLowerCase() === locationName.toLowerCase());
        }) : [];
      }

      cargoLinesToReturn = [].concat(cargoLines);

      const cargoMarkedAsLiftedIds = state.vesselActivitiesCargo.data.map((x) => x.flowLineId);

      //cargo marked as lifted in Voyage
      cargoLinesToReturn.forEach((x) => {
        if (cargoMarkedAsLiftedIds.includes(x.lineId)) {
          var lineInDb = state.vesselActivitiesCargo.data.find((y) => y.flowLineId == x.lineId);
          x.id = lineInDb.id;
          x.activityId = lineInDb.vesselActivity.id;
          x.offshoreLiftTime = lineInDb.offshoreLiftTime;
          x.isNob = lineInDb.isNob;
          x.markedAsLifted = !lineInDb.isNob;
        }
        else {
          x.markedAsLifted = false;
          x.id = null;
          x.activityId = null;
          x.voyageReportId = null;
          x.offshoreLiftTime = null;
          x.isNob = false;
        }
      });

      //get extra lifts in Voyage
      var flowVoyageId = isOutbound ? state.eCargoVoyageCargo.outbound ? state.eCargoVoyageCargo.outbound.voyageId : null : state.eCargoVoyageCargo.inbound ? state.eCargoVoyageCargo.inbound.voyageId : null;
      var extraLines = state.vesselActivitiesCargo.data.filter(x => x.isExtra && x.locationName.toLowerCase() === locationName.toLowerCase() && x.flowVoyageId === flowVoyageId);
      extraLines.map((x) => {
        x.activityId = x.vesselActivity.id;
        x.isNob = false;
        x.markedAsLifted = true;
        x.isExtra = true;
        x.destination = x.locationName;
        x.voyageId = x.flowVoyageId;
      });

      const unSyncedCargoLines = rootState.dataSyncStore.cargoLinesToBeSynced;
      const unSyncedExtraCargoLines = unSyncedCargoLines.filter((x) => x.isExtra && x.destination.toLowerCase() === locationName.toLowerCase() && x.voyageId === flowVoyageId);
      const createdExtraCargoLines = unSyncedExtraCargoLines.filter((x) => x.id === null || x.id === undefined);
      const updatedExtraCargoLineIds = unSyncedExtraCargoLines.filter((x) => x.id !== null && x.id !== undefined).map((x) => x.id);

      extraLines.forEach((x) => {
        if (updatedExtraCargoLineIds.includes(x.id)) {
          var updatedExtraCargoLine = unSyncedExtraCargoLines.find((line) => line.id === x.id);
          x.description = updatedExtraCargoLine.description;
          x.unitId = updatedExtraCargoLine.unitId;
          x.idc = updatedExtraCargoLine.idc;
        }
      });

      cargoLinesToReturn = cargoLinesToReturn.concat(extraLines);

      createdExtraCargoLines.map((x) => {
        x.markedAsLifted = true;
      });

      cargoLinesToReturn = cargoLinesToReturn.concat(createdExtraCargoLines);

      //unsynced cargo lines in Voyage
      const unsyncedIds = unSyncedCargoLines.filter((x) => !x.isExtra).map((x) => x.lineId);

      cargoLinesToReturn.forEach((x) => {
        if (unsyncedIds.includes(x.lineId)) {
          var unsyncedCargoLine = unSyncedCargoLines.find((line) => line.lineId === x.lineId);
          x.markedAsLifted = unsyncedCargoLine.offshoreLiftTime != null || (unsyncedCargoLine.activityEndDateTime != null && unsyncedCargoLine.offshoreLiftTime != null);
          x.offshoreLiftTime = unsyncedCargoLine.offshoreLiftTime;
          x.idc = unsyncedCargoLine.idc;
          x.activityId = unsyncedCargoLine.activityId;
          x.activityIdc = unsyncedCargoLine.activityIdc;
          x.voyageReportId = unsyncedCargoLine.voyageReportId;
          x.isNob = unsyncedCargoLine.isNob;
        }
      });

      return cargoLinesToReturn;
    },
  getSyncedAndUnSyncedCargoForVoyage:
    (state, getters, rootState) => (isOutbound) => {
      var cargoLinesToReturn = [];

      //cargo lines from Flow
      if (isOutbound) {
        cargoLinesToReturn = state.eCargoVoyageCargo.outbound ? state.eCargoVoyageCargo.outbound.cargoLines : [];
      }
      else {
        cargoLinesToReturn = state.eCargoVoyageCargo.inbound ? state.eCargoVoyageCargo.inbound.cargoLines : [];
      }
      const cargoMarkedAsLiftedIds = state.vesselActivitiesCargo.data.map((x) => x.flowLineId);

      //cargo marked as lifted in Voyage
      cargoLinesToReturn.forEach((x) => {
        if (cargoMarkedAsLiftedIds.includes(x.lineId)) {
          x.markedAsLifted = !x.isNob;
          var lineInDb = state.vesselActivitiesCargo.data.find((y) => y.flowLineId == x.lineId);
          x.id = lineInDb.id;
          x.activityId = lineInDb.vesselActivity.id;
          x.offshoreLiftTime = lineInDb.offshoreLiftTime;
        }
        else {
          x.markedAsLifted = false;
          x.id = null;
          x.activityId = null;
          x.voyageReportId = null;
          x.offshoreLiftTime = null;
        }
      });

      //extra lifts
      var flowVoyageId = isOutbound ? state.eCargoVoyageCargo.outbound ? state.eCargoVoyageCargo.outbound.voyageId : null : state.eCargoVoyageCargo.inbound ? state.eCargoVoyageCargo.inbound.voyageId : null;
      var extraLines = state.vesselActivitiesCargo.data.filter(x => x.isExtra && x.flowVoyageId === flowVoyageId);
      extraLines.map((x) => {
        x.activityId = x.vesselActivity.id;
        x.isNob = false;
        x.markedAsLifted = true;
        x.destination = x.locationName;
        x.voyageId = x.flowVoyageId;
      });
      cargoLinesToReturn = cargoLinesToReturn.concat(extraLines);

      //unsynced cargo lines in Voyage
      const unSyncedCargoLines = rootState.dataSyncStore.cargoLinesToBeSynced;
      const unsyncedIds = unSyncedCargoLines.filter((x) => !x.isExtra).map((x) => x.lineId);

      cargoLinesToReturn.forEach((x) => {
        if (unsyncedIds.includes(x.lineId)) {
          var unsyncedCargoLine = unSyncedCargoLines.find((line) => line.lineId === x.lineId);
          x.markedAsLifted = unsyncedCargoLine.offshoreLiftTime != null || (unsyncedCargoLine.activityEndDateTime != null && unsyncedCargoLine.offshoreLiftTime != null);
          x.offshoreLiftTime = unsyncedCargoLine.offshoreLiftTime;
          x.idc = unsyncedCargoLine.idc;
          x.activityId = unsyncedCargoLine.activityId;
          x.activityIdc = unsyncedCargoLine.activityIdc;
          x.voyageReportId = unsyncedCargoLine.voyageReportId;
        }
      });

      const unSyncedExtraCargoLines = unSyncedCargoLines.filter((x) => x.isExtra && x.flowVoyageId === flowVoyageId);
      unSyncedExtraCargoLines.map((x) => {
        x.markedAsLifted = true;
      });

      cargoLinesToReturn = cargoLinesToReturn.concat(unSyncedExtraCargoLines);

      return cargoLinesToReturn;
    },
  getVoyageValidationReport:
    (state) => state.voyageValidationReport,
  getCurrentVoyageReportId:
    (state) => state.voyageReportDetailsData.id
};

const mutations = {
  [SET_VOYAGE_REPORTS](state, voyageReports) {
    state.voyageReports = voyageReports;
  },
  [CLEAR_VOYAGE_REPORTS](state) {
    state.voyageReports = [];
  },
  [SET_VOYAGE_REPORT_DETAILS_DATA](state, voyageReportDetails) {
    state.voyageReportDetailsData = voyageReportDetails;
  },
  [CLEAR_VOYAGE_REPORT_DETAILS_DATA](state) {
    state.voyageReportDetailsData = {};
  },
  [SET_VESSEL_ACTIVITES](state, vesselActivities) {
    state.voyageVesselActivities = vesselActivities;
  },
  [CLEAR_VESSEL_ACTIVITIES](state) {
    state.voyageVesselActivities = [];
  },
  [SET_VOYAGE_VALIDATION_REPORT](state, validationReport) {
    state.voyageValidationReport = validationReport;
  },
  [CLEAR_VOYAGE_VALIDATION_REPORT](state) {
    state.voyageValidationReport = null;
  },
  [SET_ECARGO_VOYAGE_DETAILS](state, eCargoVoyageCargo) {
    state.eCargoVoyageCargo = eCargoVoyageCargo;
  },
  [CLEAR_ECARGO_VOYAGE_DETAILS](state) {
    state.eCargoVoyageCargo = null;
  },
  [SET_FORESIGHT_VOYAGE_DETAILS](state, foresightRequests) {
    state.foresightRequestsForVoyage = foresightRequests;
  },
  [CLEAR_FORESIGHT_VOYAGE_DETAILS](state) {
    state.foresightRequestsForVoyage = null;
  },
  [SET_VESSEL_ACTIVITIES_CARGO](state, vesselActivitiesCargo) {
    state.vesselActivitiesCargo = vesselActivitiesCargo;
  },
  [CLEAR_VESSEL_ACTIVITIES_CARGO](state) {
    state.vesselActivitiesCargo = [];
  },
  [SET_CALCULATING_DECK_SPACE_BOOL](state, isCalculating) {
    state.isCalculatingDeckSpace = isCalculating;
  },
};

const actions = ({
  loadVoyageReports({ commit }, activeSiteId) {
    return VoyageReportsService.getVoyageReports(activeSiteId)
      .then((x) => x.data)
      .then((voyageReports) => {
        commit(SET_VOYAGE_REPORTS, voyageReports.voyageReports);
      });
  },
  loadVoyageReportDetails({ commit }, voyageReportId) {
    return VoyageReportsService.getVoyageReportDetails(voyageReportId)
      .then((x) => x.data)
      .then((voyageReportDetails) => {
        const { voyageReport } = voyageReportDetails;
        if (voyageReport) commit(SET_VOYAGE_REPORT_DETAILS_DATA, voyageReport);
      })
      .catch((error) => ErrorHandlerHelpers.handleServiceError(error));
  },
  loadCargoInformation({ commit }, voyageReportId) {
    return VoyageReportsService.getVoyageReportDetails(voyageReportId)
      .then((x) => x.data)
      .then((voyageReportDetails) => {
        const { voyageNo, siteId } = voyageReportDetails.voyageReport;
        return ECargoService.getCargoInformation(siteId, voyageNo);
      })
      .then((eCargoResp) => {
        const { data } = eCargoResp;
        commit(SET_ECARGO_VOYAGE_DETAILS, data.eCargoVoyage);
      })
      .catch((error) => console.warn('Error connecting to eCargo', error));
  },
  loadVesselActivitiesCargo({ commit }, voyageReportId) {
    return VesselActivityCargoService.getVesselActivityCargoForVoyageReport(voyageReportId)
      .then((cargoLines) => {
        commit(SET_VESSEL_ACTIVITIES_CARGO, cargoLines);
      })
      .catch((error) => ErrorHandlerHelpers.handleServiceError(error));
  },
  updateOffshoreLiftTimeInFlow({ rootState, dispatch }, data) {
    const online = rootState.userStore.isClientConnectedToServer;
    if (online) {
      return VoyageReportsService.getVoyageReportDetails(data.voyageReportId)
        .then((x) => x.data)
        .then((voyageReportDetails) => {
          const { siteId } = voyageReportDetails.voyageReport;
          return ECargoService.updateCargoOffshoreLiftTime(siteId, data.lines.filter((x) => x.lineId !== null && x.lineId !== undefined))
        })
        .then(() => {
          dispatch('loadCargoInformation', data.voyageReportId)
            .then(() => {
              var linesToUpdate = [];
              data.lines.forEach((x) => {
                var lineUpdateModel = {
                  Id: x.id ?? null,
                  VesselActivityId: x.activityId,
                  VoyageReportId: x.voyageReportId,
                  Description: x.description,
                  UnitId: x.unitId,
                  FlowLineId: x.lineId,
                  FlowVoyageId: x.voyageId,
                  OffshoreLiftTime: x.offshoreLiftTime,
                  LocationName: x.destination ? x.destination : x.locationName,
                  IsNob: x.isNob,
                  IsExtra: x.isExtra,
                  Length: x.length,
                  Width: x.width,
                  Quantity: x.quantity,
                  StackLevel: x.stackLevel
                };
                linesToUpdate.push(lineUpdateModel);
              });
              return VesselActivityCargoService.updateVesselActivityCargos(linesToUpdate);
            })
            .then(() => {
              dispatch('loadVesselActivitiesCargo', data.voyageReportId)
                .then(() => {
                  if (data.recalculateDeckUsage) {
                    dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage');
                  }
                });
            });
        }).catch((error) => console.warn('Error connecting to eCargo', error));
    }
    else {
      dispatch('markCargoAsLiftedOffline', data);
    }
  },
  markCargoAsLiftedWithNoTime({ dispatch, rootState }, data) {
    const online = rootState.userStore.isClientConnectedToServer;
    if (online) {
      var linesToUpdate = [];
      for (var i = 0; i < data.lines.length; i++) {
        var lineUpdateModel = {
          Id: data.lines[i].id ?? null,
          VesselActivityId: data.lines[i].activityId,
          VoyageReportId: data.lines[i].voyageReportId,
          Description: data.lines[i].description,
          UnitId: data.lines[i].unitId,
          FlowLineId: data.lines[i].lineId,
          FlowVoyageId: data.lines[i].voyageId,
          OffshoreLiftTime: data.lines[i].offshoreLiftTime,
          LocationName: data.lines[i].destination,
          Length: data.lines[i].length,
          Width: data.lines[i].width,
          Quantity: data.lines[i].quantity,
          StackLevel: data.lines[i].stackLevel,
        };
        linesToUpdate.push(lineUpdateModel);
      }
      return VesselActivityCargoService.updateVesselActivityCargos(linesToUpdate)
        .then(() => {
          dispatch('loadVesselActivitiesCargo', data.voyageReportId)
            .then(() => {
              dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
            });
        }).catch((error) => ErrorHandlerHelpers.handleServiceError(error));
    }
    else {
      dispatch('markCargoAsLiftedOffline', data);
    }
  },
  markCargoAsLiftedOffline({ dispatch }, data) {
    var linesToUpdate = [];
    var linesToDelete = [];
    for (var i = 0; i < data.lines.length; i++) {
      if (data.lines[i].activityEndDateTime !== data.lines[i].offshoreLiftTime && data.lines[i].id === null && data.lines[i].idc !== undefined) {
        linesToDelete.push(data.lines[i]);
      }
      else {
        linesToUpdate.push(data.lines[i]);
      }
    }
    return Idb.updateMultipleCargoLines(linesToUpdate)
      .then(() => {
        Idb.deleteMultipleCargoLines(linesToDelete).then(() => {
          dispatch('dataSyncStore/loadCargoLinesToBeSyncedForVoyage', data.voyageReportId, { root: true })
            .then(() => {
              if (data.recalculateDeckUsage) {
                dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage');
              }
            });
        })
      })
      .catch((error) => ErrorHandlerHelpers.handleServiceError(error));
  },
  markCargoAsNob({ dispatch, rootState }, data) {
    const online = rootState.userStore.isClientConnectedToServer;
    if (online) {
      var linesToUpdate = [];
      for (var i = 0; i < data.lines.length; i++) {
        var lineUpdateModel = {
          Id: data.lines[i].id ?? null,
          VesselActivityId: data.lines[i].activityId,
          VoyageReportId: data.lines[i].voyageReportId,
          Description: data.lines[i].description,
          UnitId: data.lines[i].unitId,
          FlowLineId: data.lines[i].lineId,
          FlowVoyageId: data.lines[i].voyageId,
          OffshoreLiftTime: null,
          LocationName: data.lines[i].destination,
          IsNob: data.lines[i].isNob,
          Length: data.lines[i].length,
          Width: data.lines[i].width,
          Quantity: data.lines[i].quantity,
          StackLevel: data.lines[i].stackLevel,
        };
        linesToUpdate.push(lineUpdateModel);
      }

      return VesselActivityCargoService.markAsNob(linesToUpdate)
        .then(() => {
          dispatch('loadVesselActivitiesCargo', data.voyageReportId)
            .then(() => {
              dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
            });
        }).catch((error) => ErrorHandlerHelpers.handleServiceError(error));
    }
    else {
      var linesToUpdate = [];
      var linesToDelete = [];
      data.lines.forEach((x) => {
        if (!x.isNob && x.id === null && x.idc !== undefined) {
          linesToDelete.push(x);
        }
        else {
          linesToUpdate.push(x);
        }
      });
      return Idb.updateMultipleCargoLines(linesToUpdate)
        .then(() => {
          Idb.deleteMultipleCargoLines(linesToDelete).then(() => {
            dispatch('dataSyncStore/loadCargoLinesToBeSyncedForVoyage', data.voyageReportId, { root: true })
              .then(() => {
                dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
              });
          })
        })
        .catch((error) => ErrorHandlerHelpers.handleServiceError(error));
    }
  },
  recordExtraLifts({ dispatch, rootState }, data) {
    const online = rootState.userStore.isClientConnectedToServer;
    if (online) {
      var linesToUpdate = [];
      data.lines.forEach((x) => {
        var lineUpdateModel = {
          Id: x.id ?? null,
          VesselActivityId: x.activityId,
          VoyageReportId: x.voyageReportId,
          Description: x.description,
          UnitId: x.unitId,
          FlowLineId: x.lineId,
          FlowVoyageId: x.voyageId,
          OffshoreLiftTime: x.offshoreLiftTime,
          LocationName: x.destination,
          IsExtra: x.isExtra,
          Length: x.length,
          Width: x.width,
          Quantity: x.quantity,
          StackLevel: x.stackLevel,
        };
        linesToUpdate.push(lineUpdateModel);
      });

      return VesselActivityCargoService.recordExtraLifts(linesToUpdate)
        .then(() => {
          dispatch('loadVesselActivitiesCargo', data.voyageReportId)
          .then(() => {
            dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
          });
        }).catch((error) => ErrorHandlerHelpers.handleServiceError(error));
    }
    else {
      return Idb.updateMultipleCargoLines(data.lines)
        .then(() => {
          dispatch('dataSyncStore/loadCargoLinesToBeSyncedForVoyage', data.voyageReportId, { root: true })
          then(() => {
            dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
          });
        })
        .catch((error) => ErrorHandlerHelpers.handleServiceError(error));
    }
  },
  deleteExtraLift({ dispatch, rootState }, extraLift) {
    const { id, voyageReportId } = extraLift;
    const online = rootState.userStore.isClientConnectedToServer;
    if (online && id) {
      return VesselActivityCargoService.deleteExtraLift(id)
        .then(() => {
          dispatch('loadVesselActivitiesCargo', voyageReportId)
            .then(() => {
              dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
            });
        })
        .catch((error) => ErrorHandlerHelpers.handleServiceError(error));
    }
  },
  editExtraLift({ dispatch, rootState }, extraLift) {
    const online = rootState.userStore.isClientConnectedToServer;
    extraLift.activityEndDateTime = extraLift.offshoreLiftTime;
    if (online && extraLift.id && !extraLift.idc) {
      var lineUpdateModel = {
        Id: extraLift.id ?? null,
        VesselActivityId: extraLift.activityId,
        VoyageReportId: extraLift.voyageReport.id,
        Description: extraLift.description,
        UnitId: extraLift.unitId,
        FlowLineId: extraLift.lineId,
        FlowVoyageId: extraLift.voyageId,
        OffshoreLiftTime: extraLift.offshoreLiftTime,
        LocationName: extraLift.destination,
        IsExtra: extraLift.isExtra,
        Length: extraLift.length,
        Width: extraLift.width,
        Quantity: extraLift.quantity,
        StackLevel: extraLift.stackLevel,
      };
      return VesselActivityCargoService.updateVesselActivityCargos([lineUpdateModel])
        .then(() => {
          dispatch('loadVesselActivitiesCargo', extraLift.voyageReport.id)
          .then(() => {
            dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
          });
        }).catch((error) => ErrorHandlerHelpers.handleServiceError(error));
    }
    else {
      dispatch('markCargoAsLiftedOffline', { lines: [extraLift], voyageReportId: extraLift.voyageReport ? extraLift.voyageReport.id : extraLift.voyageReportId, recalculateDeckUsage: false });
    }
  },
  deleteVesselActivityCargoForVesselActivity({ dispatch }, data) {
    return VoyageReportsService.getVoyageReportDetails(data.voyageReportId)
      .then((x) => x.data)
      .then((voyageReportDetails) => {
        const { siteId } = voyageReportDetails.voyageReport;
        var lines = state.vesselActivitiesCargo.data.filter((x) => x.vesselActivity.id === data.vesselActivityId);
        var linesToSendToFlow = [];
        lines.forEach((x) => {
          if (!x.isExtra && !x.isNob) {
            var lineToSendToFlow = {
              lineId: x.flowLineId,
              voyageId: x.flowVoyageId,
              offshoreLiftTime: null,
            };
            linesToSendToFlow.push(lineToSendToFlow);
          }
        });
        return ECargoService.updateCargoOffshoreLiftTime(siteId, linesToSendToFlow);
      }).then(() => {
        return VesselActivityCargoService.deleteVesselActivityCargos(data.vesselActivityId)
      })
      .then(() => dispatch('loadVesselActivitiesCargo', data.voyageReportId))
      .catch((error) => ErrorHandlerHelpers.handleServiceError(error));
  },
  loadPortPlanningInformation({ commit }, voyageReportId) {
    return VoyageReportsService.getVoyageReportDetails(voyageReportId)
      .then((x) => x.data)
      .then((voyageReportDetails) => {
        const { voyageReport } = voyageReportDetails;
        const { siteId, voyageNo, vesselName } = voyageReport;
        return ForesightService.getVoyageForesightDetails(siteId, voyageNo, vesselName);
      })
      .then((x) => x.data)
      .then((foresightData) => {
        commit(SET_FORESIGHT_VOYAGE_DETAILS, foresightData.requests);
      })
      .catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
  loadVoyageVesselActivities({ commit }, voyageReportId) {
    return VesselActivitiesService.getVoyageVesselActivities(voyageReportId)
      .then((x) => x.data)
      .then((vesselActivitiesData) => {
        commit(SET_VESSEL_ACTIVITES, vesselActivitiesData.vesselActivities);
      })
      .catch((error) => ErrorHandlerHelpers.handleServiceError(error));
  },
  createVoyageReport({ commit, rootState, dispatch }, report) {
    const online = rootState.userStore.isClientConnectedToServer;
    if (online) {
      return VoyageReportsService.createVoyageReport(report)
        .then((x) => x.data)
        .then((voyageReportData) => {
          dispatch('loadVoyageReports', report.siteId);
        }).catch((error) => ErrorHandlerHelpers.handleServiceError(error));
    }
    // If Offline - store in ..ToBeSynced data.
    const ts = new Date().getTime(); // Use Timestamp as unique Id.
    const reportWithTimestamp = { ...report };
    reportWithTimestamp.clientCreatedAt = ts;
    commit('dataSyncStore/ADD_VOYAGE_REPORT_TO_BE_SYNCED', reportWithTimestamp, { root: true });
    return Idb.saveVoyageReport(reportWithTimestamp)
      .then(() => dispatch('dataSyncStore/loadVoyageReportsToBeSynced', null, { root: true }));
  },
  deleteVoyageReport({ commit, dispatch, state }, id) {
    return VoyageReportsService.deleteVoyageReport(id)
      .catch((error) => ErrorHandlerHelpers.handleServiceError(error));
  },
  updateVoyageReport({ rootState, dispatch }, updateData) {
    const online = rootState.userStore.isClientConnectedToServer;
    if (online && updateData.id && !updateData.idc) {
      return VoyageReportsService.updateVoyageReport(updateData)
        .then((x) => x.data)
        .then((data) => {
          dispatch('loadVoyageReportDetails', updateData.id);
          dispatch('loadVoyageValidationReport', updateData.id);
        }).catch((error) => ErrorHandlerHelpers.handleServiceError(error));
    }

    return Idb.updateVoyageReport(updateData)
      .then(() => dispatch('dataSyncStore/loadVoyageReportsToBeSynced', null, { root: true }))
      .then((x) => dispatch('dataSyncStore/loadOfflineVoyageReportDetails', updateData.idc ?? updateData.id, { root: true }))
      .catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
  async createVesselActivity({ commit, rootState, dispatch, getters }, activity) {
    const online = rootState.userStore.isClientConnectedToServer;
    var vesselActivitiesProm = getters.getSyncedAndUnSyncedVesselActivities;
    const vesselActivities = await vesselActivitiesProm;
    const activitiesOccuringAfterCreated = vesselActivities.filter((x) => x.startDateTimeLt > activity.startDateTimeLt).length > 0;

    if (online) {
      let createdVesselActivity = null;
      return VesselActivitiesService.createVesselActivity(activity)
        .then((response) => {
          createdVesselActivity = response.data.createdVesselActivity;
          dispatch('loadVoyageValidationReport', activity.voyageReportId);
        })
        .then(() => dispatch('loadVoyageVesselActivities', activity.voyageReportId))
        .then(() => {
          if (activitiesOccuringAfterCreated) {
            dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
          }
        })
        .then(() => createdVesselActivity)
        .catch((error) => ErrorHandlerHelpers.handleServiceError(error));
    }
    // If Offline - store in ..ToBeSynced data.
    const ts = new Date().getTime(); // Use Timestamp as unique Id.
    const vesselActivityWithTimestamp = { ...activity };
    vesselActivityWithTimestamp.clientCreatedAt = ts;

    return Idb.saveVesselActivity(vesselActivityWithTimestamp).then((createdActivityIdc) => {
      const { id, idc } = state.voyageReportDetailsData;
      // Vessel activity can be saved with a voyageReportId (server-side created)
      // or a with a voyageReportIdc (client-side created report)
      if (id) {
        dispatch('loadVoyageVesselActivities', id);
        dispatch('dataSyncStore/loadVesselActivitiesToBeSynced', id, { root: true })
          .then(() => {
            if (activitiesOccuringAfterCreated) {
              dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
            }
          });
      } else if (idc) {
        dispatch('dataSyncStore/loadVesselActivitiesToBeSynced', idc, { root: true })
          .then(() => {
            if (activitiesOccurringAfterCreated) {
              dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
            }
          });
      }

      vesselActivityWithTimestamp.idc = createdActivityIdc;
      return vesselActivityWithTimestamp;
    }).catch((error) => ErrorHandlerHelpers.handleServiceError(error));
  },
  deleteVesselActivity({ dispatch, rootState, state }, params) {
    const { id, idc } = params;
    const online = rootState.userStore.isClientConnectedToServer;
    if (online && id && !idc) {
      return VesselActivitiesService.deleteVesselActivity(id)
        .then(() => {
          dispatch('deleteVesselActivityCargoForVesselActivity', { vesselActivityId: id, voyageReportId: state.voyageReportDetailsData.id })
            .then(() => {
              dispatch('loadVoyageVesselActivities', state.voyageReportDetailsData.id)
                .then(() => {
                  dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
                })
            });
          dispatch('loadVoyageValidationReport', state.voyageReportDetailsData.id);
        })
        .catch((error) => ErrorHandlerHelpers.handleServiceError(error));
    }

    // If Offline -  //check IndexedDb
    const offlineActivity = rootState.dataSyncStore.vesselActivitiesToBeSynced
      .find((x) => x.idc === id || x.id === id);
    return Idb.deleteVesselActivity(offlineActivity).then(() => {
      const voyageReportId = state.voyageReportDetailsData.id;
      const voyageReportIdc = state.voyageReportDetailsData.idc;
      const cargoLinesForActivity = rootState.dataSyncStore.cargoLinesToBeSynced.filter((x) => x.activityIdc === idc);
      return Idb.deleteMultipleCargoLines(cargoLinesForActivity).then(() => {
        dispatch('dataSyncStore/loadCargoLinesToBeSyncedForVoyage', voyageReportId ?? voyageReportIdc, { root: true });
        if (voyageReportId) {
          dispatch('loadVoyageVesselActivities', voyageReportId);
          dispatch('dataSyncStore/loadVesselActivitiesToBeSynced', voyageReportId, { root: true })
            .then(() => {
              dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
            });
        }
        if (voyageReportIdc) {
          dispatch('dataSyncStore/loadVesselActivitiesToBeSynced', voyageReportIdc, { root: true })
            .then(() => {
              dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
            });
        }
      });
    }).catch((error) => ErrorHandlerHelpers.handleServiceError(error));
  },
  updateVesselActivity({ dispatch, rootState, state, getters }, updateData) {
    const online = rootState.userStore.isClientConnectedToServer;
    if (online && updateData.id && !updateData.idc) {
      var oldVesselActivityData = state.voyageVesselActivities.find((x) => updateData.id === x.id);
      var endDateTimeUpdated = dateTimeHelpers.dateTimeStringRemoveSeconds(oldVesselActivityData.endDateTimeLt) !== updateData.endDateTimeLt;
      var startDateTimeUpdated = dateTimeHelpers.dateTimeStringRemoveSeconds(oldVesselActivityData.startDateTimeLt) !== updateData.startDateTimeLt;
      var activityTypeUpdated = oldVesselActivityData.activityType !== updateData.activityType;
      return VesselActivitiesService.updateVesselActivity(updateData)
        .then(() => {
          dispatch('loadVoyageVesselActivities', state.voyageReportDetailsData.id).then(() => {
            if (endDateTimeUpdated && oldVesselActivityData.activity.isCargoHandlingActivity && rootState.userStore.user.activeSiteConfig.isECargoEnabled) {
              var lines = state.vesselActivitiesCargo.data.filter((x) => x.vesselActivity.id === updateData.id);
              if (lines.length > 0) {
                var linesToSendToFlow = [];
                lines.forEach((x) => {
                  var lineToSendToFlow = {
                    lineId: x.flowLineId,
                    voyageId: x.flowVoyageId,
                    offshoreLiftTime: updateData.endDateTimeLt,
                    id: x.id,
                    voyageReportId: x.voyageReport.id,
                    activityId: x.vesselActivity.id,
                    description: x.description,
                    isNob: x.isNob,
                    isExta: x.isExtra,
                    destination: x.destination ?? x.locationName,
                    unitId: x.unitId,
                    length: x.length,
                    width: x.width,
                    quantity: x.quantity,
                    stackLevel: x.stackLevel,
                  };
                  linesToSendToFlow.push(lineToSendToFlow);
                });
                dispatch('updateOffshoreLiftTimeInFlow', { lines: linesToSendToFlow, voyageReportId: updateData.voyageReport.id, recalculateDeckUsage: true });
              }
            }
            else {
              if (endDateTimeUpdated || startDateTimeUpdated || activityTypeUpdated) {
                dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage');
              }
            }
            dispatch('loadVoyageValidationReport', state.voyageReportDetailsData.id);
          });
        }).catch((error) => ErrorHandlerHelpers.handleServiceError(error));
    }

    // if offline then update locally
    return Idb.updateVesselActivity(updateData).then((response) => {
      const activityBeforeEdit = getters.getSyncedAndUnSyncedVesselActivities.find((x) => x.id === updateData.id || (x.idc !== null && x.idc === updateData.idc));
      var endDateTimeUpdated = dateTimeHelpers.dateTimeStringRemoveSeconds(activityBeforeEdit.endDateTimeLt) !== updateData.endDateTimeLt;
      var startDateTimeUpdated = dateTimeHelpers.dateTimeStringRemoveSeconds(activityBeforeEdit.startDateTimeLt) !== updateData.startDateTimeLt;
      var activityTypeUpdated = activityBeforeEdit.activityType !== updateData.activityType;
      if (activityBeforeEdit.activity != null && activityBeforeEdit.activity.isCargoHandlingActivity && endDateTimeUpdated && rootState.userStore.user.activeSiteConfig.isECargoEnabled) {
        const outboundCargoLinesForActivity = getters.getSyncedAndUnSyncedCargoForLocation(true, activityBeforeEdit.locationName,).filter((x) => {
          return ((x.activityId !== null && x.activityId === updateData.id) || (x.activityIdc != undefined && updateData.idc != null && x.activityIdc === updateData.idc)) &&
            x.markedAsLifted;
        });
        const inboundCargoLinesForActivity = getters.getSyncedAndUnSyncedCargoForLocation(false, activityBeforeEdit.locationName,).filter((x) => {
          return ((x.activityId !== null && x.activityId === updateData.id) || (x.activityIdc != undefined && updateData.idc != null && x.activityIdc === updateData.idc)) &&
            x.markedAsLifted;
        });
        const cargoLines = outboundCargoLinesForActivity.concat(inboundCargoLinesForActivity);
        cargoLines.forEach((x) => {
          x.activityEndDateTime = updateData.endDateTimeLt;
          x.offshoreLiftTime = updateData.endDateTimeLt;
          x.activityIdc = response;
          x.voyageReportId = updateData.voyageReport ? updateData.voyageReport.id : updateData.voyageReportId;
        })
        return Idb.updateMultipleCargoLines(cargoLines).then((x) => {
          const { id, idc } = state.voyageReportDetailsData;
          dispatch('dataSyncStore/loadCargoLinesToBeSyncedForVoyage', id ?? idc, { root: true })
            .then(() => {
              dispatch('dataSyncStore/loadVesselActivitiesToBeSynced', id ?? idc, { root: true })
                .then(() => {
                  if (endDateTimeUpdated || startDateTimeUpdated || activityTypeUpdated) {
                    dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
                  }
                });
            })
        });
      }
      else {
        const { id, idc } = state.voyageReportDetailsData;
        dispatch('dataSyncStore/loadVesselActivitiesToBeSynced', id ?? idc, { root: true })
          .then(() => {
            if (endDateTimeUpdated || startDateTimeUpdated || activityTypeUpdated) {
              dispatch('recalculateDeckSpaceUsedForAllActivitiesOnVoyage')
            }
          });
      }

    }).catch((error) => ErrorHandlerHelpers.handleServiceError(error));
  },
  async recalculateDeckSpaceUsedForAllActivitiesOnVoyage({ dispatch, rootState, commit, getters, state }) {
    if (rootState.userStore.user.activeSiteConfig.isECargoEnabled) {
      const online = rootState.userStore.isClientConnectedToServer;
      commit(SET_CALCULATING_DECK_SPACE_BOOL, true);

      const promVesselActivitiesToBeSynced = getters.getSyncedAndUnSyncedVesselActivities;
      const promOutboundCargoLinesToBeSynced = getters.getSyncedAndUnSyncedCargoForVoyage(true);
      const promInboundCargoLinesToBeSynced = getters.getSyncedAndUnSyncedCargoForVoyage(false);
      const data = await Promise.all([
        promVesselActivitiesToBeSynced,
        promOutboundCargoLinesToBeSynced,
        promInboundCargoLinesToBeSynced,
      ]);

      var activitiesToUpdate = VesselActivityDeckSpaceCalculatorMixin.methods.recalculateDeckSpaceUsedForAllActivitiesOnVoyage(
        data[0].sort((a, b) => {
          if (!a.endDateTimeLt) return 1;
          if (!b.endDateTimeLt) return -1;
          if (a.startDateTimeLt < b.startDateTimeLt) return -1;
          if (a.startDateTimeLt > b.startDateTimeLt) return 1;
          if (a.endDateTimeLt < b.endDateTimeLt) return -1;
          if (a.endDateTimeLt > b.endDateTimeLt) return 1;
          return -1;
        }),
        state.eCargoVoyageCargo.outbound,
        state.eCargoVoyageCargo.inbound,
        data[1],
        data[2]);

      if (activitiesToUpdate.length > 0) {
        activitiesToUpdate.forEach((x) => {
          if (x.activity != null) x.activityId = x.activity.id;
        })
        if (online) {
          const dataToBeSynced = {
            voyageReportsToBeSynced: [],
            vesselActivitiesToBeSynced: activitiesToUpdate,
            bulkTransactionsToBeSynced: [],
            tanksWithCurrentStatusToBeSynced: [],
            passengersToBeSynced: [],
            safetyObservationsToBeSynced: [],
            allCargoLinesToBeSynced: [],
          };
          var activeSiteId = rootState.userStore.getActiveSiteId;
          DataSyncService.syncData(dataToBeSynced, activeSiteId)
            .then(() => {
              dispatch('loadVoyageVesselActivities', state.voyageReportDetailsData.id);
            })
            .catch((error) => ErrorHandlerHelpers.handleServiceError(error))
            .finally(() => commit(SET_CALCULATING_DECK_SPACE_BOOL, false));
        }
        else {
          Idb.updateMultipleVesselActivities(activitiesToUpdate)
            .then(() => {
              const { id, idc } = state.voyageReportDetailsData;
              dispatch('dataSyncStore/loadVesselActivitiesToBeSynced', id ?? idc, { root: true })
            })
            .catch((error) => ErrorHandlerHelpers.handleServiceError(error))
            .finally(() => commit(SET_CALCULATING_DECK_SPACE_BOOL, false));
        }
      }
    }
  },
  getVoyageReportAsExcelFile({ commit }, voyageReportId) {
    return VoyageReportsService.getVoyageReportAsExcelFile(voyageReportId);
  },
  // VOYAGE REPORT VALIDATION
  loadVoyageValidationReport({ commit }, voyageReportId) {
    ValidationService.getVoyageValidationReport(voyageReportId)
      .then((x) => x.data.report)
      .then((validationReport) => {
        commit(SET_VOYAGE_VALIDATION_REPORT, validationReport);
      })
      .catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
  getValidationReportAsExcelFile({ commit }, voyageReport) {
    return ValidationService.getVoyageValidationReportAsExcelFile(voyageReport);
  },
  clearVoyageData({ commit }) {
    commit(CLEAR_VESSEL_ACTIVITIES);
    commit('dataSyncStore/CLEAR_VESSEL_ACTIVITIES_TO_BE_SYNCED', null, { root: true });
    commit(CLEAR_VOYAGE_VALIDATION_REPORT);
    commit(CLEAR_ECARGO_VOYAGE_DETAILS);
    commit(CLEAR_VESSEL_ACTIVITIES_CARGO);
  },
});

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
